import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import "../style/Portal.css";

const Portal = ({ children, onClose, backgroundImage }) => {
  const portalRoot = document.getElementById("portal-root");

  const element = document.createElement("div");
  element.classList.add("portal-container");

  useEffect(() => {
    portalRoot.appendChild(element);
    return () => {
      portalRoot.removeChild(element);
    };
  }, [element, portalRoot]);

  return ReactDOM.createPortal(
    <div className="portal-overlay" onClick={onClose}>
      <div
        className="portal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <div className="portal-overlay-bg"></div>
        <button className="portal-close" onClick={onClose}>
          &times;
        </button>
        {children}
      </div>
    </div>,
    element
  );
};

export default Portal;
